/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Allowed signup pathways exposed on the ChallengeLoginModal. EMAIL is the 6-digit-code flow; DISCORD/GOOGLE/APPLE are the OAuth popup paths.
 * @export
 */
export const SignupMethod = {
    EMAIL: 'EMAIL',
    DISCORD: 'DISCORD',
    GOOGLE: 'GOOGLE',
    APPLE: 'APPLE'
} as const;
export type SignupMethod = typeof SignupMethod[keyof typeof SignupMethod];


export function instanceOfSignupMethod(value: any): boolean {
    for (const key in SignupMethod) {
        if (Object.prototype.hasOwnProperty.call(SignupMethod, key)) {
            if (SignupMethod[key as keyof typeof SignupMethod] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SignupMethodFromJSON(json: any): SignupMethod {
    return SignupMethodFromJSONTyped(json, false);
}

export function SignupMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupMethod {
    return json as SignupMethod;
}

export function SignupMethodToJSON(value?: SignupMethod | null): any {
    return value as any;
}

export function SignupMethodToJSONTyped(value: any, ignoreDiscriminator: boolean): SignupMethod {
    return value as SignupMethod;
}

